import { apiClient } from './client'

export interface MyPlayerTeam {
  player_id: number
  team_id: number
  team_name: string
  jersey_number: number | null
  position_name: string
  is_sub: boolean
  retired: boolean
}

export interface TeamPlayerStatsRow {
  player_id: number
  team_id: number
  team_name: string
  first_name: string
  last_name: string
  is_sub: boolean
  games_played: number
  at_bats: number
  singles: number
  doubles: number
  triples: number
  home_runs: number
  strikeouts: number
  walks: number
  fielders_choice: number
  sacrifice: number
  rbis: number
  runs: number
  stolen_bases: number
  ba: number
  obp: number
  slg: number
  ops: number
}

export interface TeamStatsFilters {
  year?: string
  season_id?: string
  league_id?: string
}

export const getMyTeams = async (): Promise<MyPlayerTeam[]> => {
  const res = await apiClient.get('/me/teams')
  return res.data ?? []
}

export const getMyStats = async (filters: TeamStatsFilters = {}): Promise<TeamPlayerStatsRow[]> => {
  const res = await apiClient.get('/me/stats', { params: filters })
  return res.data ?? []
}

export const getTeamPlayerStats = async (
  teamId: number,
  filters: TeamStatsFilters = {}
): Promise<TeamPlayerStatsRow[]> => {
  const res = await apiClient.get(`/teams/${teamId}/stats/players`, { params: filters })
  return res.data ?? []
}

export const getTourState = async (): Promise<{ completed: boolean }> => {
  const res = await apiClient.get('/me/tour')
  return res.data
}

export const completeTour = async (): Promise<void> => {
  await apiClient.post('/me/tour/complete')
}
